import React, { ChangeEvent, useEffect, useMemo, useRef } from "react";
import { Row, Col, Input, Checkbox, Space, Button, Popover } from "antd";
import { BsSliders } from "react-icons/bs";
import { Role } from "src/entity/map-company-user/user-in-company";
import { Company } from "src/entity/map-company-user/map-company-user";
import { GetUserManagementFilter } from "src/entity/user-management/users-state.entity";
import { debounce } from "lodash";
import { componentPalette } from "src/theme/component-palette";

interface SearchFilterProps {
  placeholder: string;
  roles: Role[] | null | undefined;
  company: Company[] | null;
  action: (filter: GetUserManagementFilter) => Promise<void>;
  filterRole: string[];
  setFilterRole: (value: string[]) => void;
  filterCompany: string[];
  setFilterCompany: (value: string[]) => void;
  textSearch: string;
  setTextSearch: (value: string) => void;
  pageSize: number;
  setPage: (page: number) => void;
}

const chunkSize = 6;

export const SearchUser: React.FunctionComponent<SearchFilterProps> = ({ ...props }) => {
  const {
    roles,
    company,
    action,
    filterRole,
    setFilterRole,
    filterCompany,
    setFilterCompany,
    textSearch,
    setTextSearch,
    pageSize,
    setPage,
  } = props;

  const getChunkCompanyFilter = useMemo(() => {
    if (!Array.isArray(company)) return [];

    const chunks = [];
    for (let i = 0; i < company.length; i += chunkSize) {
      chunks.push(company.slice(i, i + chunkSize));
    }
    return chunks;
  }, [company]);

  const debounceRequestApi = useRef(
    debounce((textSearch, filterRole, filterCompany) => {
      action({
        page: 1,
        limit: pageSize,
        textSearch,
        roles: filterRole as string[],
        company: filterCompany as string[],
      });
    }, 500),
  ).current;

  useEffect(() => {
    debounceRequestApi(textSearch, filterRole, filterCompany);
  }, [textSearch, filterRole, filterCompany, debounceRequestApi]);

  const resetFilter = () => {
    setFilterCompany([]);
    setFilterRole([]);
  };

  const onChangeFilter = (checkboxValue: string[], type: string) => {
    if (type === "role") {
      setFilterRole(checkboxValue);
    } else {
      setFilterCompany(checkboxValue);
    }
    setPage(1);
  };
  // console.log("getChunkCompanyFilter: ", getChunkCompanyFilter);
  const content = (
    <Col className="pr-0" style={{ maxWidth: "80vw" }}>
      <Row>
        <Col>
          <Space direction="vertical">
            <strong>Role</strong>
            <Checkbox.Group style={{ width: "100%" }} value={filterRole} onChange={(e) => onChangeFilter(e, "role")}>
              <Space direction="vertical">
                {roles?.map((item, index) => {
                  return (
                    <Checkbox key={"checkbox-" + index} value={item._id}>
                      {item.roleName}
                    </Checkbox>
                  );
                })}
              </Space>
            </Checkbox.Group>
          </Space>
        </Col>
        <Col className="pl-2" style={{ maxWidth: "70vw" }}>
          <Space direction="vertical" style={{ maxWidth: `${getChunkCompanyFilter?.length ? getChunkCompanyFilter.length * 10 : 10}rem` }}>
            <strong>Company</strong>
            <Checkbox.Group
              className={"custom-check-box-group"}
              style={{ maxWidth: `${getChunkCompanyFilter?.length ? getChunkCompanyFilter.length * 10 : 10}rem` }}
              value={filterCompany}
              onChange={(e) => onChangeFilter(e, "company")}
            >
              <Row className="w-full" gutter={[16, 16]}>
                {getChunkCompanyFilter.map((chunk, index) => (
                  <Space direction="vertical" key={index} style={{ minWidth: "5rem", maxWidth: "10rem" }}>
                    {chunk.map((item, idx) => (
                      <Checkbox key={"checkbox-" + idx} value={item._id}>
                        {item.companyName}
                      </Checkbox>
                    ))}
                  </Space>
                ))}
              </Row>
            </Checkbox.Group>
          </Space>
        </Col>
      </Row>
      <Row justify={"space-between"} className="pt-2">
        <Button size="small" onClick={resetFilter}>
          Reset
        </Button>
        <div />
      </Row>
    </Col>
  );

  const suffix = (
    <Popover content={content} title="" trigger={["hover", "click"]} placement="bottomRight">
      {/* <Button ghost size="small"> */}
      <BsSliders
        style={{ cursor: "pointer" }}
        color={filterCompany.length || filterRole.length ? componentPalette.primary : componentPalette.black}
      />
      {/* </Button> */}
    </Popover>
  );

  const onSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setTextSearch(e.target.value);
  };

  return <Input placeholder="input search text" onChange={onSearch} style={{}} suffix={suffix} />;
};
